import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    LOADING: false,
    lang: '',
    access_token: ''
  },
  mutations: {
    showLoading(state) {
      state.LOADING = true
    },
    hideLoading(state) {
      state.LOADING = false
    },
    getLanguage(state) {

    },
    setLanguage(state, language) {

    },
  },
  actions: {

  }
})